
import Vue from 'vue'

/***
 * 
 * Your includes here
 * 
 */


 
// Components
import '@/theme/components'
import '@/theme/plugins'


import 'chartist/dist/chartist.min.css'

Vue.use(require('vue-chartist'))